import { render, staticRenderFns } from "./GiftCodeWidgetSlider.vue?vue&type=template&id=47fe4114"
import script from "./GiftCodeWidgetSlider.vue?vue&type=script&lang=js"
export * from "./GiftCodeWidgetSlider.vue?vue&type=script&lang=js"
import style0 from "./GiftCodeWidgetSlider.vue?vue&type=style&index=0&id=47fe4114&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports